import Request from '../../data/request'

export default class ApiImport {

    constructor() {}

    importTasks(companyId:ID, tasks:any) {
        return new Request(this, 'POST', 'company/' + companyId + '/import/tasks', {
            tasks: tasks
        });
    }

    importProjects(projects:any) {
        return new Request(this, 'POST', 'company/' + gd.companyId + '/import/projects', {
            projects: projects
        });
    }

    importMaps(companyId:ID) {
        return new Request(this, 'GET', 'company/' + gd.companyId + '/import/maps');
    }

    static importCRMContacts(crmContacts:any) {
        return new Request(this, 'POST', 'company/{0}/import/crm-contacts'.f(gd.companyId), {
            crmContacts
        })
    }

    static importCRMAccounts(crmAccounts:any) {
        return new Request(this, 'POST', 'company/{0}/import/crm-accounts'.f(gd.companyId), {
            crmAccounts
        })
    }

    static importTasksNew(tasks:any) {
        return new Request(this, 'POST', 'company/' + gd.companyId + '/import/tasks-v2', {
            tasks: tasks
        });
    }
}
